// Use require below so we can dynamically import during build-time.
import { useDispatch } from 'react-redux'

import { store as storeDev } from './configureStore.dev'
import { store as storeProd } from './configureStore.prod'

export const store =
  process.env.NODE_ENV === 'production' ? storeProd : storeDev

export const useAppDispatch = () => useDispatch()
